import React, { useCallback, useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDropzone } from "react-dropzone";
import Select from "react-select";
import { Col, Form, FormFeedback, Label } from "reactstrap";
import * as Yup from "yup";
import axios from "axios";
import CommonDialog from "components/Common/CommonDialog";
import { API_URL } from "../../http/url.helper";
import { callAdditionalDocument, callDeleteDocuments, callgetAdditonalDocument } from "http/fundLync/entityDocuments.helper";
import { getDropDownList } from "http/fundLync/dropdown.helper";
import { getEntityWiseDeal } from "http/fundLync/deal.helper";
import { decryptedValue, isPermission, uId } from "common/utility";

import {

  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Row,
  Table,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from "reactstrap";
import { downloadSystemConfigFile } from "http/UAM/systemConfig.helper";
import ToastDialog from "components/Common/ToastDialog";
import { getOneEntity } from "http/fundLync/entityAndAddress.helper";
const AdditionalDocuments = (props) => {
  document.title = "Additional Documents | FundLync";
  const urlParams = new URLSearchParams(window.location.search);
  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
  const [additionalDocSelectedGroup, setAdditionalDocSelectedGroup] =useState(null);
  const [deal, setDeal] =useState(null);
  const [additionalSelectedOptions, setAdditionalSelectedOptions] = useState([]);
  const [dealTable, setDealTable] =useState([]);
  const [isEditBankPermission, setEditBankPermission] = useState(false);
  const [dealList, setDealList] = useState([]);
  const [isNewDataPermission, setNewDataPermission] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({});
  const [errorMessage, setErrorMessage] = useState(null);
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [entityId, setEntityId] = useState('')
  const [encodedId, setEncodedId] = useState('')
  const [isFinSelected, setIsFinSelected ] = useState(false)
  const validationFileUpload = useFormik({
    enableReinitialize: true,
    initialValues: {
      fileUpload: [],
      // deal_id: '',
    },
    validationSchema: Yup.object({
      fileUpload: Yup.array()
        .min(1, "At least one file is required")
        .required("Files are required"),
    }),
    onSubmit: (values) => {
      handleFileUpload(values);
      const delay = 3000; 
      setTimeout(() => {
        callDocDetailsAfterSave();
      }, delay);
    },
  });


  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        validationFileUpload.setFieldValue("fileUpload", [
          ...validationFileUpload.values.fileUpload,
          ...acceptedFiles,
        ]);
      }
    },
    [validationFileUpload.values.fileUpload]
  );
  useEffect(() => {
    const userDetails = decryptedValue(localStorage.getItem("user"));
    if (userDetails.entityType === "Partner" || userDetails.entityType === "Owner") {
      const id = urlParams.get("id");
      setEncodedId(id);
      const decodedId = atob(id);
      setEntityId(decodedId);
    } else {
      setEntityId(userDetails.entityId);
    }
  }, []);
  
  useEffect(() => {
    if (entityId) {
      getOneEntity({ entityId })
        .then((response) => {
          if (response.data) {
            setIsFinSelected(response.data[0]?.entityType === "Financier");
          }
        })
        .catch((error) => {
          console.error("Error fetching entity:", error);
        });
    }
  }, [entityId]);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const checkPermissions = async () => {
    const isAddpermission = await isPermission("address", "create_permission");
    const editAddressPermission = await isPermission("address", "edit_permission");
    setNewDataPermission(isAddpermission);
    setEditBankPermission(editAddressPermission);
  };
  useEffect(() => {
    getDropDownList({ dropdownName: "Additional Documents" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find(
            (dv) => dv.dropdownName === "Additional Documents"
          )?.dropdownValues || [];
        setAdditionalSelectedOptions(dropdownValues);
      })
      .catch((error) => {
        console.error("Error fetching dropdown list:", error);
      });
      if(entityId){
      getEntityWiseDeal({ entityId })
      .then((response) => {
        if (response.code == 200 && response.status) {
          setDealList(response.data.rows);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    }
      checkPermissions();
      if(entityId){
      callgetAdditonalDocument({entity_id: entityId})
      .then((response) => {
        if (response.length > 0) {
          const sortedDocuments = response.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
          setDealTable(sortedDocuments);
        }else{
          setDealTable([]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    }
  }, [entityId]);

  const callDocDetailsAfterSave = () => {
    callgetAdditonalDocument({ entity_id: entityId })
      .then((response) => {
        const sortedDocuments = response.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setDealTable(sortedDocuments);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleFileUpload = async (values) => {
    setErrorMessage(null)
    setLoading(true);
    try {
      const user = decryptedValue(localStorage.getItem("user"));
      const userid = user.id;
      const fileType = additionalDocSelectedGroup?.value;
  
      if (!isFinSelected && (!deal || !deal.value)) {
        setErrorMessage("Please select a deal.");
        setLoading(false);
        return;
      }
  
      const uploadedUrls = await uploadFile(values.fileUpload);
      let response ;
      if(isFinSelected){
        response = callAdditionalDocument({
          entity_id: entityId,
          filename: fileType,
          file_path: uploadedUrls,
          created_by: userid,
        });
      }else{
        response = callAdditionalDocument({
          entity_id: entityId,
          deal_id: deal?.value || null,
          filename: fileType,
          file_path: uploadedUrls,
          created_by: userid,
        });
      }
  
        setToastInfo({
          message: "Files Uploaded Successfully",
          showToast: true,
          role: "success",
        });
        validationFileUpload.resetForm(); 
        setAdditionalDocSelectedGroup(null); 
        setDeal(null); 
        setUploadProgress({}); 
        setErrorMessage(null); 
        callDocDetailsAfterSave();
        
    } catch (error) {
      setErrorMessage(error.message);
      setToastInfo({
        message: error.message,
        showToast: true,
        role: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  
  const uploadFile = async (files) => {
    const uploadPromises = files.map(
      (file) =>
        new Promise((resolve, reject) => {
          if (file) {
            setUploadProgress((prev) => ({ ...prev, [file.name]: 0 }));
            let formData = new FormData();
            formData.append("upl", file);
            const config = {
              onUploadProgress: (progressEvent) => {
                const percentage = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                );

                setUploadProgress((prev) => ({
                  ...prev,
                  [file.name]: percentage,
                }));
              },
            };
            axios
              .post(`${API_URL}/s3/uploadSystemConfigFiles`, formData, config)
              .then((response) => {
                if (response.status === 200) {
                  resolve(response.data[0].fileName);
                } else {
                  reject(response.data.message);
                }
                callDocDetailsAfterSave()
              })
              .catch((error) => {
                reject(error.response?.data?.message || error.message);
              });
          } else {
            reject("File is undefined or null");
          }
        })
    );

    try {
      const uploadedUrls = await Promise.all(uploadPromises);
      return uploadedUrls;
    } catch (error) {
      throw new Error(error);
    }
  };

  const dialogAction = (action) => {
    if (action === 1) {
      validationFileUpload.handleSubmit();
    }
    setShowCommonDialog({ isShow: false });
  };

  function downloadFile(base64String, ext, fileName) {
    let source = "";
    if (ext == "zip") {
      source = `data:application/zip;base64,${base64String}`;
      const link = document.createElement("a");
      link.href = source;
      link.download = fileName;
      link.click();
    } else {
      source = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64String}`;
      const link = document.createElement("a");
      link.href = source;
      link.download = fileName;
      link.click();
    }
  }
  function formatFunction(file, showToastCallback) {
    const str = file.substring(file.indexOf("com") + 4);
    const filename = file.substring(file.lastIndexOf("/") + 1);
    const ext = str.split(".").pop();
    const obj = {
      fileName: str,
    };
  
    downloadSystemConfigFile(obj)
      .then((response) => {
        if (response.code === 200) {
          downloadFile(response.result, ext, filename);
          showToastCallback({
            message: "Downloaded successfully",
            showToast: true,
            role: "success",
          });
        } else {
          showToastCallback({
            message: response.message,
            showToast: true,
            role: "error",
          });

        }
      })
      .catch((error) => {});
  }
  const handleToast = (info) => {
    setToastInfo(info);
  };
  
  const useDeleteDocument = async (id, setToastInfo) => {
    try {
      const response = await callDeleteDocuments({ id: id });
      
        setToastInfo({
          message: response.message,
          showToast: true,
          role: "error",
        });
      
      callDocDetailsAfterSave()
    } catch (error) {
      setToastInfo({
        message: "An error occurred while deleting the note.",
        showToast: true,
        role: "error",
      });
      return false;
    }
  
  };

  // Function to extract the filename from the URL
  const extractFileName = (url) => {
    const segments = url.split('/');
    return decodeURIComponent(segments[segments.length - 1]);
  };
  
  function formatDateTime(dateTimeString) {
    const date = new Date(dateTimeString);
    
    // Extract date components
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
  
    // Extract time components
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    
    // Determine AM/PM
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    
    // Format date and time
    const formattedDate = `${day}-${month}-${year}`;
    const formattedTime = `${String(hours).padStart(2, '0')}:${minutes}:${seconds} ${ampm}`;
    
    return `${formattedDate} , ${formattedTime}`;
  }
  

  return (
    <React.Fragment>
      <div className="row">
        {!isFinSelected && (
          <Col sm="12" md="6" className="mb-3">
            <Label>Select Deal *</Label>
            <Select
              value={deal}
              onChange={(e) => {
                setDeal(e)
                validationFileUpload.setFieldValue("deal_id", e.value);
              }}
              options={dealList.map((o) => ({
                label: o.dealName,
                value: o.id,
              }))}
            />
          </Col>
        )}
      
      </div>
      <div className="row">
      
        <Col sm="12" md="6" className="mb-3">
          <Label>Select Document Type to Upload</Label>
          <Select
            value={additionalDocSelectedGroup}
            onChange={(e) => {
              setAdditionalDocSelectedGroup(e);
              validationFileUpload.resetForm();
            }}
            options={additionalSelectedOptions.map((o) => ({
              label: o.displayName,
              value: o.dropdownValue,
            }))}
          />
        </Col>
        <Col xl="12">
          {additionalDocSelectedGroup &&
            additionalDocSelectedGroup.value === "username_password" && (
              <Form
                className="needs-validation"
                onSubmit={(e) => {
                  e.preventDefault();
                  setShowCommonDialog({
                    isShow: true,
                    message: "Are you sure want to submit this Documents?",
                  });
                  return false;
                }}
              >
                <Col
                  sm="12"
                  md="4"
                  className="d-flex justify-content-center mt-3"
                >
                  <button
                    type="submit"
                    className="btn btn-success"
                    disabled={loading}
                  >
                    {loading && (
                      <span
                        className="spinner-border spinner-border-sm ms-2 me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    )}
                    {loading && <span>Saving</span>}
                    {!loading && <span>Save</span>}
                  </button>
                </Col>
              </Form>
            )}
          {additionalDocSelectedGroup &&
            additionalDocSelectedGroup.value !== "username_password" && (
              <Form
                className="needs-validation"
                onSubmit={(e) => {
                  e.preventDefault();
                  setShowCommonDialog({
                    isShow: true,
                    data: { type: "doc_file" },
                    message: "Are you sure want to submit this Document?",
                  });
                  return false;
                }}
              >
                <div className="row d-flex align-items-center">
                  <Col sm="12"></Col>
                  <Col sm="12" md="6">
                    <div>
                      <div className="d-flex flex-column">
                        <Label
                          htmlFor="horizontal-email-Input"
                          className="col-form-label"
                        >
                          Upload File <span className="text-primary">(allowed formats: .xlsx, .xls, .jpg, .png, .jpeg, .pdf)</span><br />
                          <small className="text-danger">*The maximum file size allowed is 10 MB</small>
                        </Label>
                        <div
                          className="drop"
                          onClick={() =>
                            validationFileUpload.setFieldTouched(
                              "fileUpload",
                              true,
                              setErrorMessage(null),
                              setUploadProgress({})
                            )
                          }
                        >
                          <div {...getRootProps()} className="text-wrapper">
                            <div className="centered">
                              <input
                                type="file"
                                multiple
                                name="formatDocument"
                                id="itrFileExcel"
                                accept=".jpg, .png, .jpeg, .pdf, .xlsx, .xls"
                                {...getInputProps({
                                  onClick: () => {
                                    setErrorMessage(null); 
                                    setUploadProgress({}); 
                                  }
                                })}
                              />
                              {/* <label
                                style={{ marginBottom: 0, fontSize: "14px" }}
                                htmlFor="itrFileExcel"
                              > */}
                                <img
                                  src="https://scfuat.cashinvoice.in/frontend/assets/themes/image/icon/cloud.png"
                                  className="img-fluid"
                                  style={{ width: "30px" }}
                                  alt="Upload"
                                />
                                {isDragActive && (
                                  <p className="textLink">Drop here</p>
                                )}
                                <span className="textLink">
                                  Browse files to attach
                                </span>{" "}
                                or Drop
                              {/* </label> */}
                            </div>
                          </div>
                        </div>
                        {validationFileUpload.values.fileUpload.length > 0 && (
                          <ul className="mt-2">
                            {validationFileUpload.values.fileUpload.map(
                              (file, index) => (
                                <li key={index}>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <span>{file.name}</span>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-danger"
                                      style={{border:"none", borderRadius:"50%", fontWeight:"800"}}
                                      onClick={() => {
                                        const updatedFiles = validationFileUpload.values.fileUpload.filter(
                                          (_, fileIndex) => fileIndex !== index
                                        );
                                        validationFileUpload.setFieldValue("fileUpload", updatedFiles);
                                      }}
                                    >
                                      X
                                    </button>
                                  </div>
                                  
                                  {uploadProgress[file.name] > 0 &&
                                    !errorMessage && (
                                      <div className="progress mt-2">
                                        <div
                                          className="progress-bar bg-success"
                                          role="progressbar"
                                          style={{
                                            width: `${
                                              uploadProgress[file.name]
                                            }%`,
                                          }}
                                          aria-valuenow="0"
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        >
                                          {`${uploadProgress[file.name]}%`}
                                        </div>
                                      </div>
                                    )}
                                  {errorMessage && (
                                    <div className="alert alert-danger mt-2">
                                      {errorMessage}
                                    </div>
                                  )}
                                </li>
                              )
                            )}
                          </ul>
                        )}
                        {validationFileUpload.touched.fileUpload &&
                          validationFileUpload.errors.fileUpload && (
                            <FormFeedback
                              type="invalid"
                              style={{ display: "block" }}
                            >
                              {validationFileUpload.errors.fileUpload}
                            </FormFeedback>
                          )}
                      </div>
                      <hr />
                    </div>
                  </Col>
                  <Col sm="12"></Col>
                  <Col
                    sm="12"
                    md="6"
                    className="d-flex justify-content-center mb-4"
                  >
                    <button
                      type="submit"
                      className="btn btn-success save-customer"
                      disabled={loading}
                    >
                      {loading && (
                        <span
                          className="spinner-border spinner-border-sm ms-2 me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      )}
                      {loading && <span>Saving</span>}
                      {!loading && <span>Save</span>}
                    </button>
                  </Col>
                </div>
              </Form>
            )}
        </Col>
        <Col xs="12" className="mt-1 mb-2">
                  <div className="table-responsive">
                    <Table className="table table-bordered table-striped mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>Id</th>
                          {!isFinSelected && (
                            <th>Deal Name</th>
                          )}
                          <th>File Name</th>
                          <th>Uploaded By</th>
                          <th>Uploaded At</th>
                          <th>Files</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dealTable.length == 0? (
                          <tr>
                            <td colSpan={7} className="text-center">
                              No data found
                            </td>
                          </tr>
                        ) : (
                          dealTable.map((elem, index) => (
                            <tr key={uId()}>
                              <td>{index + 1}</td>
                              {!isFinSelected && (
                                <td>
                                {elem.deal?.deal_name ?? ""} 
                              </td>
                              )}
                              
                              <td>{elem.filename}</td>
                              <td>{elem.createdByUser.firstName} {elem.createdByUser.lastName}</td>
                              <td>{formatDateTime(elem.createdAt)}</td>
                              <td>
                                {elem.filePath?.map((file, fileIndex) => (
                                  
                                  <React.Fragment key={fileIndex}>
                                    <i className="mdi mdi-download"
                                    key={fileIndex}
                                    style={{
                                      fontSize: "25px",
                                      cursor: "pointer",
                                      color: "#34c38f",
                                    }}
                                    onKeyUp={() => {}}
                                    onClick={() => {
                                      formatFunction(
                                        file,
                                        handleToast
                                      );
                                    }}
                                    id={`download-tooltip-${index}-${fileIndex}`}
                                    >
                                    </i>
                                    <UncontrolledTooltip placement="top" target={`download-tooltip-${index}-${fileIndex}`}>
                                    {extractFileName(file)}
                                    </UncontrolledTooltip>
                                  </React.Fragment>   
                                ))}
                              </td>
                              <td>
                                <UncontrolledDropdown>
                                  <DropdownToggle
                                    tag="a"
                                    className="card-drop"
                                  >
                                    <i className="mdi mdi-dots-horizontal font-size-18"></i>
                                  </DropdownToggle>

                                  {isEditBankPermission && <DropdownMenu className="dropdown-menu-end">
                                    <DropdownItem
                                      onClick={() =>
                                        useDeleteDocument(
                                          elem.id,
                                          setToastInfo
                                        )
                                      }
                                    >
                                      <i
                                        className="mdi mdi-trash-can font-size-16 text-dark me-1"
                                        id="edittooltip"
                                      ></i>
                                      Delete
                                      <UncontrolledTooltip
                                        placement="top"
                                        target="edittooltip"
                                      >
                                        Delete
                                      </UncontrolledTooltip>
                                    </DropdownItem>
                                  </DropdownMenu>}
                                </UncontrolledDropdown>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Col>
              
      </div>

      <hr className="hr-divider" />

      {showCommonDialog.isShow && (
        <CommonDialog
          isShow={showCommonDialog.isShow}
          message={showCommonDialog.message}
          data={showCommonDialog.data}
          postitiveBtn={"Submit"}
          negativeBtn={"Close"}
          onCloseFn={dialogAction}
        />
      )}
       <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </React.Fragment>
  );
};

export default AdditionalDocuments;
